// weather.js — lightweight today-forecast helper (spec §2.1).
//
// Uses Open-Meteo's free forecast API (no key). Cached 30 min in memory;
// gracefully returns null when offline or on error so the dashboard strip
// simply hides. Safe for any tenant base lat/lng.

const CACHE_MS = 30 * 60 * 1000;
let cache = { at: 0, data: null };

// WMO weather-code → short label (subset used by the strip).
const WEATHER_CODES = {
  0: 'Clear', 1: 'Mostly clear', 2: 'Partly cloudy', 3: 'Overcast',
  45: 'Fog', 48: 'Rime fog',
  51: 'Light drizzle', 53: 'Drizzle', 55: 'Heavy drizzle',
  61: 'Light rain', 63: 'Rain', 65: 'Heavy rain',
  71: 'Light snow', 73: 'Snow', 75: 'Heavy snow',
  80: 'Light showers', 81: 'Showers', 82: 'Heavy showers',
  95: 'Thunderstorm', 96: 'Thunderstorm + hail', 99: 'Thunderstorm + hail',
};

export async function fetchTodayWeather(lat, lng, { force = false } = {}) {
  if (!lat || !lng) return null;
  const now = Date.now();
  if (!force && cache.data && now - cache.at < CACHE_MS) return cache.data;

  try {
    const url =
      `https://api.open-meteo.com/v1/forecast?latitude=${encodeURIComponent(lat)}` +
      `&longitude=${encodeURIComponent(lng)}` +
      `&daily=weathercode,precipitation_sum,temperature_2m_max,temperature_2m_min` +
      `&timezone=auto&forecast_days=1`;
    const res = await fetch(url);
    if (!res.ok) return null;
    const json = await res.json();
    const daily = json?.daily;
    if (!daily || !daily.time?.length) return null;

    const data = {
      label: WEATHER_CODES[daily.weathercode?.[0]] || 'Mixed',
      precip: Math.round((daily.precipitation_sum?.[0] || 0) * 10) / 10,
      tMax: Math.round(daily.temperature_2m_max?.[0] ?? 0),
      tMin: Math.round(daily.temperature_2m_min?.[0] ?? 0),
      fetchedAt: now,
    };
    cache = { at: now, data };
    return data;
  } catch {
    return null; // offline / blocked — strip hides gracefully
  }
}
